export type WorkspaceTool = "inspect" | "codes" | "components" | "quality";
export type WorkspaceLayout = "wide" | "compact" | "narrow";
export type WorkspacePane = "browser" | "inspector";

export interface WorkspaceShellState {
  readonly browserOpen: boolean;
  readonly inspectorOpen: boolean;
}

export const defaultWorkspaceShellState: WorkspaceShellState = {
  browserOpen: true,
  inspectorOpen: true
};

export function toggleWorkspacePane(
  state: WorkspaceShellState,
  pane: WorkspacePane,
  layout: WorkspaceLayout
): WorkspaceShellState {
  const isOpen = pane === "browser" ? state.browserOpen : state.inspectorOpen;
  if (isOpen) {
    return pane === "browser"
      ? { ...state, browserOpen: false }
      : { ...state, inspectorOpen: false };
  }
  if (layout === "narrow") {
    return pane === "browser"
      ? { browserOpen: true, inspectorOpen: false }
      : { browserOpen: false, inspectorOpen: true };
  }
  return pane === "browser"
    ? { ...state, browserOpen: true }
    : { ...state, inspectorOpen: true };
}

export function openInspectorForTool(
  state: WorkspaceShellState,
  layout: WorkspaceLayout
): WorkspaceShellState {
  if (state.inspectorOpen && (layout !== "narrow" || !state.browserOpen)) return state;
  return layout === "narrow"
    ? { browserOpen: false, inspectorOpen: true }
    : { ...state, inspectorOpen: true };
}

export function reconcileWorkspaceForLayout(
  state: WorkspaceShellState,
  layout: WorkspaceLayout
): WorkspaceShellState {
  if (layout !== "narrow" || !state.browserOpen || !state.inspectorOpen) return state;
  return { browserOpen: true, inspectorOpen: false };
}
